

// import React, { useState, useCallback } from 'react';
// import {
//   TextField,
//   Button,
//   Typography,
//   Box,
//   Alert,
//   CircularProgress,
//   Link,
//   Paper,
// } from '@mui/material';
// import { Link as RouterLink } from 'react-router-dom';
// import Particles from 'react-tsparticles';
// import { loadFull } from 'tsparticles';
// import jwtDecode from 'jwt-decode';
// import axios from 'axios';

// // Add API_BASE
// const API_BASE = process.env.REACT_APP_API_URL;

// function Login({ onLogin, onSwitchToRegister }) {
//   const [form, setForm] = useState({ email: '', password: '' });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);

//   const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

//   const handleLogin = async e => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await axios.post(`${API_BASE}/api/auth/login`, form);
//       localStorage.setItem('token', res.data.token);
//       const user = jwtDecode(res.data.token);
//       onLogin({ username: user.username || user.id, id: user.id });
//     } catch (err) {
//       setMessage(err.response?.data?.message || 'Invalid credentials');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const particlesInit = useCallback(async (engine) => {
//     await loadFull(engine);
//   }, []);

//   return (
//     <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
//       <Particles
//         id="tsparticles"
//         init={particlesInit}
//         options={{
//           fullScreen: { enable: true, zIndex: 0 },
//           background: { color: { value: "#0a192f" } },
//           fpsLimit: 60,
//           particles: {
//             number: { value: 50, density: { enable: true, area: 800 } },
//             color: { value: "#50E3C2" },
//             shape: { type: "circle" },
//             opacity: {
//               value: 0.5,
//               random: { enable: true, minimumValue: 0.1 }
//             },
//             size: {
//               value: 3,
//               random: { enable: true, minimumValue: 1 }
//             },
//             move: {
//               enable: true,
//               speed: 2,
//               direction: "none",
//               random: false,
//               straight: false,
//               outModes: "out"
//             },
//             links: {
//               enable: true,
//               distance: 150,
//               color: "#50E3C2",
//               opacity: 0.4,
//               width: 1
//             }
//           },
//           detectRetina: true,
//         }}
//       />

//       <Paper
//         elevation={10}
//         sx={{
//           position: 'relative',
//           zIndex: 1,
//           maxWidth: 450,
//           mx: 'auto',
//           mt: 10,
//           p: 6,
//           bgcolor: 'rgba(30, 50, 70, 0.85)',
//           color: 'white',
//           borderRadius: 4,
//           boxShadow: '0 12px 48px rgba(0,0,0,0.5)',
//           backdropFilter: 'blur(10px)',
//         }}
//       >
//         <Typography variant="h4" align="center" gutterBottom sx={{ mb: 3 }}>
//           Login
//         </Typography>
//         {message && (
//           <Alert severity="error" sx={{ mb: 3, fontWeight: 'bold' }}>
//             {message}
//           </Alert>
//         )}
//         <form onSubmit={handleLogin} style={{ marginBottom: '12px' }}>
//           <TextField
//             type="email"
//             name="email"
//             label="Email"
//             fullWidth
//             required
//             margin="normal"
//             value={form.email}
//             onChange={handleChange}
//             autoFocus
//             variant="filled"
//             InputLabelProps={{ style: { color: '#A0C8F0' } }}
//             sx={{
//               backgroundColor: 'rgba(255,255,255,0.1)',
//               borderRadius: 1,
//               input: { color: 'white' }
//             }}
//           />
//           <TextField
//             type="password"
//             name="password"
//             label="Password"
//             fullWidth
//             required
//             margin="normal"
//             value={form.password}
//             onChange={handleChange}
//             variant="filled"
//             InputLabelProps={{ style: { color: '#A0C8F0' } }}
//             sx={{
//               backgroundColor: 'rgba(255,255,255,0.1)',
//               borderRadius: 1,
//               input: { color: 'white' }
//             }}
//           />
//           <Button
//             type="submit"
//             variant="contained"
//             color="secondary"
//             fullWidth
//             disabled={loading}
//             sx={{ mt: 4, py: 1.2, fontWeight: 'bold' }}
//           >
//             {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
//           </Button>
//         </form>
//         <Typography
//           mt={1}
//           align="center"
//           color="lightblue"
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             gap: 1,
//             flexWrap: 'wrap',
//           }}
//         >
//           <span>Don't have an account?</span>
//           <Link
//             href="#"
//             onClick={e => {
//               e.preventDefault();
//               onSwitchToRegister();
//             }}
//             underline="hover"
//             color="inherit"
//             sx={{ cursor: 'pointer' }}
//           >
//             Register here
//           </Link>
//           <span>|</span>
//           <Link
//             component={RouterLink}
//             to="/forgot-password"
//             underline="hover"
//             color="inherit"
//             sx={{ cursor: "pointer" }}
//           >
//             Forgot Password?
//           </Link>
//         </Typography>
//       </Paper>
//     </Box>
//   );
// }

// export default Login;


import React, { useState, useCallback } from 'react';
import { Box, Button, Typography, TextField, Alert, CircularProgress, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import jwtDecode from 'jwt-decode';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

function Login({ onLogin, onSwitchToRegister }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      const res = await axios.post(`${API_BASE}/api/auth/login`, form);
      localStorage.setItem('token', res.data.token);
      const user = jwtDecode(res.data.token);
      onLogin({ username: user.username || user.id, id: user.id });
    } catch (err) {
      setMessage(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const inputSx = {
    '& .MuiFilledInput-root': {
      bgcolor: '#0E1318',
      borderRadius: '10px',
      border: '1px solid #1A2228',
      '&:hover': { bgcolor: '#111820', borderColor: '#253035' },
      '&.Mui-focused': { bgcolor: '#111820', borderColor: '#00C2B3' },
      '&::before, &::after': { display: 'none' },
    },
    '& .MuiFilledInput-input': {
      color: '#F0F4F8',
      fontFamily: "'Outfit', sans-serif",
      fontSize: 15, py: 1.5,
    },
    '& .MuiInputLabel-root': {
      color: '#3A4A58',
      fontFamily: "'Outfit', sans-serif",
      '&.Mui-focused': { color: '#00C2B3' },
    },
  };

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden', bgcolor: '#090C0F' }}>
      <Particles
        id="tsparticles-login"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: { value: "#090C0F" } },
          fpsLimit: 60,
          particles: {
            number: { value: 40, density: { enable: true, area: 900 } },
            color: { value: ["#00C2B3", "#007A70"] },
            shape: { type: "circle" },
            opacity: { value: 0.3, random: true },
            size: { value: 2, random: true },
            move: { enable: true, speed: 1, outModes: "out" },
            links: { enable: true, distance: 140, color: "#00C2B3", opacity: 0.12, width: 1 },
          },
          detectRetina: true,
        }}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0 }}
      />

      <Box sx={{
        position: 'relative', zIndex: 1, height: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2,
      }}>
        <Box sx={{
          width: '100%', maxWidth: 400,
          bgcolor: '#0E1318', border: '1px solid #1A2228',
          borderRadius: '16px', p: { xs: 3, sm: 4.5 },
        }}>
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
            <Box sx={{
              width: 36, height: 36, borderRadius: '8px',
              bgcolor: '#00C2B3', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="17" height="17" viewBox="0 0 22 22" fill="none">
                <path d="M3 6C3 4.9 3.9 4 5 4H17C18.1 4 19 4.9 19 6V13C19 14.1 18.1 15 17 15H12L8 19V15H5C3.9 15 3 14.1 3 13V6Z" fill="#090C0F"/>
              </svg>
            </Box>
            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 700,
              fontSize: 18, color: '#F0F4F8',
            }}>YapZone</Typography>
          </Box>

          <Typography sx={{
            fontFamily: "'Outfit', sans-serif", fontWeight: 600,
            fontSize: 24, color: '#F0F4F8', mb: 0.5,
          }}>
            Welcome back
          </Typography>
          <Typography sx={{
            fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#3A4A58', mb: 3,
          }}>
            Sign in to continue to your chats
          </Typography>

          {message && (
            <Alert
              severity="error"
              sx={{
                mb: 3, bgcolor: '#1A0E0E', color: '#FF6B6B',
                border: '1px solid #2A1515', borderRadius: '8px',
                fontFamily: "'Outfit', sans-serif",
                '& .MuiAlert-icon': { color: '#FF6B6B' },
              }}
            >
              {message}
            </Alert>
          )}

          <form onSubmit={handleLogin}>
            <TextField
              type="email" name="email" label="Email address"
              fullWidth required margin="normal"
              value={form.email} onChange={handleChange}
              autoFocus variant="filled"
              sx={inputSx}
            />
            <TextField
              type="password" name="password" label="Password"
              fullWidth required margin="normal"
              value={form.password} onChange={handleChange}
              variant="filled"
              sx={{ ...inputSx, mb: 0.5 }}
            />

            <Box sx={{ textAlign: 'right', mb: 3 }}>
              <Link
                component={RouterLink} to="/forgot-password"
                sx={{
                  fontFamily: "'Outfit', sans-serif", fontSize: 13,
                  color: '#00C2B3', textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Forgot password?
              </Link>
            </Box>

            <Button
              type="submit" fullWidth
              disabled={loading}
              sx={{
                py: 1.5,
                bgcolor: '#00C2B3', color: '#090C0F',
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 600, fontSize: 15,
                borderRadius: '10px', textTransform: 'none',
                '&:hover': { bgcolor: '#00D5C5' },
                '&.Mui-disabled': { bgcolor: '#0A3530', color: '#004A44' },
              }}
            >
              {loading ? <CircularProgress size={22} sx={{ color: '#090C0F' }} /> : 'Sign in'}
            </Button>
          </form>

          <Typography sx={{
            fontFamily: "'Outfit', sans-serif", fontSize: 14,
            color: '#3A4A58', textAlign: 'center', mt: 3,
          }}>
            Don't have an account?{' '}
            <Link
              href="#"
              onClick={e => { e.preventDefault(); onSwitchToRegister(); }}
              sx={{ color: '#00C2B3', textDecoration: 'none', fontWeight: 500, '&:hover': { textDecoration: 'underline' } }}
            >
              Create one
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;